<script>
import { Trans } from '@utils/translation'
import appConfig from '@src/app.config'
import { authComputed, merchantComputed } from '@state/helpers'
import 'babel-polyfill'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  name: "App",
  data() {
    return {
      beforeScrollTop: 0,
      scrollTop: 0,
      delta: 0,
      fixMessengerTarget: 600,
      showButton: false
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    merchantAlias() {
      return this.$route.params.merchantAlias || this.currentMerchant.alias;
    }
  },
  mounted() {
    this.initLanguage();

    const userAgent = window.navigator.userAgent;
    const isIE = (userAgent.indexOf('MSIE') > 0) || (userAgent.indexOf('Trident/') > 0);

    if(!isIE) {
      window.onstorage = (e) => {

        // setTimeout(()=> {

        if(e.key === `auth.currentMember.${this.merchantAlias}`) {
          const newValue = JSON.parse(e.newValue);

          console.log('登入狀態已更新', this.merchantAlias, newValue[this.merchantAlias]);

          this.$store.dispatch('auth/setCurrentUser', {
            member: newValue,
            merchantAlias: this.merchantAlias
          });

          if(this.$route.meta.authRequired) {
            if(!this.loggedIn) {
              this.$router.push({
                name: 'login',
                params: {
                  merchantAlias: this.merchantAlias
                },
                query: {
                  language: this.$route.query.language,
                  redirectFrom: this.$route.fullpath
                }
              })
            }
          }
        }

        // }, 1000)

      };
    }

    this.scrollTop = this.getScrollTop();
    setTimeout(() => {
      if (document.getElementById('show-preview')) {
        this.fixMessengerTarget = document.getElementById('show-preview').offsetTop - 412;
      }
    }, 3000);
    document.addEventListener('scroll', this.onScroll);


    setTimeout(() => {
      this.showButton = true
    }, 3000)
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    /**
     * 根據使用者偏好變更語言
     */
    initLanguage() {
      this.$store
        .dispatch('set/setLanguage', {
          language: Trans.getUserSupportedLang(),
        })
    },
    onScroll() {
      this.scrollTop = this.getScrollTop();
      // this.delta = this.scrollTop - this.beforeScrollTop > 0 ? 'down' : 'up';
      this.delta = this.scrollTop - this.beforeScrollTop;
      this.beforeScrollTop = this.scrollTop;
    },
    getScrollTop() {
      let scrollTop = 0;

      if (typeof window.pageYOffset !== 'undefined') {
        scrollTop = window.pageYOffset
      } else if (
        typeof document.compatMode !== 'undefined' &&
        document.compatMode !== 'BackCompat'
      ) {
        scrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        scrollTop = document.body.scrollTop
      }

      return scrollTop
    },
  },
};
</script>
<template>
  <div id="app" :class="[`page-${$route.name}`, { 'is-mobile-fix-messenger': scrollTop < fixMessengerTarget && $route.name === 'booking-product', 'is-mobile-hide-messenger': delta > 0 && scrollTop > 10  }]">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath"/>
    <a v-if="currentMerchant && showButton" class="button-phone" :href="`tel:${currentMerchant.phoneNumber}`">
      <BaseIcon name="phone-volume" icon-style="fal" />
    </a>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// https://buefy.org/documentation/start
@import '@src/design/cutomize_buefy.scss';
@import '@src/design/global.scss';
@import '@src/design/booking.scss';
@import '@design';


</style>
